import { takeLatest, all, takeEvery } from 'redux-saga/effects'; // fork, take,  takeEvery, takeLeading
import { SAGA_ACTIONS } from '../../_config';

import * as storeSaga from './storeSaga';
import * as userSaga from './userSaga';
import * as dataSourceSaga from './dataSourceSaga';
import * as sentimentAnalysisSaga from './sentimentAnalysisSaga';
import * as reviewratingSaga from './reviewratingSaga';
import * as topicwordSaga from './topicwordSaga';
import * as chatAssistantSaga from './chatAssistantSaga';
import * as recommendationSaga from './recommendationSaga';

export function* sagas() {
	yield all([
		takeEvery(SAGA_ACTIONS.USER.LOGIN, userSaga.loginUser),
		takeEvery(SAGA_ACTIONS.USER.REGISTER, userSaga.register),
		takeEvery(SAGA_ACTIONS.USER.FORGET_PASSWORD, userSaga.forgotPassword),
		takeEvery(SAGA_ACTIONS.USER.RESET_PASSWORD, userSaga.resetPassword),
		takeEvery(SAGA_ACTIONS.USER.LOGOUT, userSaga.logout),

		takeEvery(SAGA_ACTIONS.STORE.GET_STORE, storeSaga.getStore),
		takeEvery(SAGA_ACTIONS.STORE.ADD_STORE, storeSaga.addStore),
		takeEvery(SAGA_ACTIONS.STORE.UPDATE_STORE, storeSaga.updateStoreInfo),
		takeEvery(SAGA_ACTIONS.STORE.BRANCH_LIST, storeSaga.getStoreBranches),
		takeEvery(SAGA_ACTIONS.STORE.ADD_BRANCH, storeSaga.addStoreBranch),
		takeEvery(SAGA_ACTIONS.STORE.UPDATE_BRANCH, storeSaga.updateStoreBranchInfo),
		takeEvery(SAGA_ACTIONS.STORE.GET_STORE_TYPE, storeSaga.getStoreTypes),

		takeEvery(SAGA_ACTIONS.DATASOURCE.GET_DATASOURCES, dataSourceSaga.getDataSource),
		takeEvery(SAGA_ACTIONS.DATASOURCE.ADD_EXTERNAL_DATASOURCE, dataSourceSaga.addExternalDataSource),
		takeEvery(SAGA_ACTIONS.DATASOURCE.ADD_INTERNAL_DATASOURCE, dataSourceSaga.addInternalDataSource),

		takeEvery(SAGA_ACTIONS.SENTIMENT.GET_SENTIMENT_TIMELINE, sentimentAnalysisSaga.getSentimentTimeline),
		takeEvery(SAGA_ACTIONS.SENTIMENT.GET_SENTIMENT_BREAKDOWN, sentimentAnalysisSaga.getSentimentBreakdown),
		takeEvery(SAGA_ACTIONS.SENTIMENT.GET_SENTIMENT_OVERALL, sentimentAnalysisSaga.getSentimentOverall),
		takeEvery(SAGA_ACTIONS.SENTIMENT.GET_SENTIMENT_COMPARISON, sentimentAnalysisSaga.getSentimentComparison),
		takeEvery(SAGA_ACTIONS.SENTIMENT.GET_REVIEW_VOLUMN, sentimentAnalysisSaga.getReviewVolumn),
		takeEvery(SAGA_ACTIONS.SENTIMENT.GET_REVIEW_RATING, sentimentAnalysisSaga.getRatingStars),
		
		takeEvery(SAGA_ACTIONS.TOPIC.TOPIC_LIST, topicwordSaga.getTopics),
		takeEvery(SAGA_ACTIONS.WORD.WORD_LIST, topicwordSaga.getWords),

		takeEvery(SAGA_ACTIONS.REVIEW.GET_REVIEW_SUMMARY, reviewratingSaga.getReviewSummary),
		takeEvery(SAGA_ACTIONS.REVIEW.REVIEW_LIST, reviewratingSaga.getReviewList),

		takeEvery(SAGA_ACTIONS.RATING.RATING_SUMMARY, reviewratingSaga.getRatingSummary),
		takeEvery(SAGA_ACTIONS.REVIEW.REVIEW_LIST, reviewratingSaga.getReviewList),
		
		takeEvery(SAGA_ACTIONS.ASSISTANT.SEND, chatAssistantSaga.postQuery),

		takeEvery(SAGA_ACTIONS.RECOMMENDATION.RECOMMENDATION_LIST, recommendationSaga.getRecommendationList),
		
		// takeEvery(SAGA_ACTIONS.USER.IMAGE_LIST, userSaga.getImages),
		// takeEvery(SAGA_ACTIONS.USER.IMAGE_UPLOAD, userSaga.uploadImage),

		

	]);
}